<div class="mon-avatar" 
     *ngIf="displayInitials"
     [style.width.px]="size"
     [style.height.px]="size"
     [style.border-radius]="rounded ? '50%' : '4px'"
     [style.background-color]="getBackgroundColor()"
     [style.color]="textColor"
     [style.display]="'flex'"
     [style.align-items]="'center'"
     [style.justify-content]="'center'"
     [style.font-size.px]="size * 0.4">
  {{ displayInitials }}
</div>
